import toast, { Toaster, ToastBar } from 'react-hot-toast';

function AppToaster() {
  return (
    <Toaster
      position="top-right"
      containerStyle={{
        top: 60,
      }}
      toastOptions={{
        error: {
          duration: 5000,
          style: {
            background: 'rgb(var(--color-error-subtle))',
            color: 'rgb(var(--color-error-emphasis))',
            border: '2px solid rgb(var(--color-error))',
            borderRadius: '8px',
            fontSize: '14px',
            padding: '12px 16px',
            boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
          },
        },
      }}
    >
      {(t) => (
        <ToastBar toast={t}>
          {({ message }) => (
            <>
              {message}
              <button
                onClick={() => toast.dismiss(t.id)}
                style={{
                  marginLeft: '8px',
                  background: 'transparent',
                  border: 'none',
                  color: 'inherit',
                  cursor: 'pointer',
                  fontSize: '16px',
                  lineHeight: 1,
                  opacity: 0.7,
                  padding: '0 2px',
                }}
                aria-label="Dismiss notification"
              >
                ✕
              </button>
            </>
          )}
        </ToastBar>
      )}
    </Toaster>
  );
}

export default AppToaster;

